import Spacer from './spacer';
import StatusBanner from './status-banner';
import { RouteBaseErrors } from '@/util-react-router/types/route-base-errors';

export interface PageErrorBannersProps {
  /** Error from action func */
  actionErrors?: RouteBaseErrors;
  actionErrorClassName?: string;
  /** Error from load func */
  loaderErrors?: RouteBaseErrors;
  loaderErrorClassName?: string;
}

/**
 *  Display generic standard errors for pages. Can be used to show either OR both action and loader errors.
 */
export default function PageErrorBanners({
  actionErrors,
  loaderErrors,
  actionErrorClassName,
  loaderErrorClassName,
}: PageErrorBannersProps) {
  return (
    <>
      {actionErrors?.error ? (
        <>
          <StatusBanner
            variant="error"
            message={{
              text: actionErrors.error,
            }}
            shouldScrollToTop={true}
            className={actionErrorClassName}
          />
          <Spacer variant="height16" />
        </>
      ) : null}
      {loaderErrors?.error ? (
        <>
          <StatusBanner
            variant="error"
            message={{ text: loaderErrors.error }}
            shouldScrollToTop={true}
            className={loaderErrorClassName}
          />
          <Spacer variant="height16" />
        </>
      ) : null}
    </>
  );
}
